/* global localStorage */
import decode from 'jwt-decode'
import { isValidToken } from './validations'

export const keyName = 'authToken'

export function getAuthToken () {
  const token = localStorage.getItem(keyName)
  const valid = isValidToken(token)

  if (!valid) {
    removeAuthToken()
    return undefined
  }

  return token
}

export function setAuthToken (token) {
  return localStorage.setItem(keyName, token)
}

export function removeAuthToken () {
  localStorage.removeItem(keyName)
}

export function getAuthTokenProp (prop) {
  const token = getAuthToken()
  if (!token) {
    return undefined
  }

  const decodedToken = decode(token)
  return decodedToken[prop]
}



// WEBPACK FOOTER //
// ./src/shared/utils/auth/auth.js